import type {
  PunchListsAdvancedSortState,
  PunchListsSavedSortState,
  PunchListsSortState,
} from '../types';

const isSortRuleArray = (
  value: PunchListsSavedSortState | readonly PunchListsSortState[]
): value is readonly PunchListsSortState[] => Array.isArray(value);

export const normalizePunchListsSortState = (
  sortState: PunchListsSavedSortState | readonly PunchListsSortState[] | null | undefined
): PunchListsSortState[] => {
  if (!sortState) return [];
  if (isSortRuleArray(sortState)) return [...sortState];
  if ('rules' in sortState) return [...sortState.rules];
  return [sortState];
};

export const serializePunchListsSortState = (
  rules: readonly PunchListsSortState[]
): PunchListsAdvancedSortState | null => (rules.length > 0 ? { rules: [...rules] } : null);
